import { CompanyDetails } from "./types/CompanyDetails";
import { MyAccountInformation } from "./features/common/my-account/types/MyAccountInformation";
import { AR, BusinessFlow, InstallerType, ProductLine } from "./types/enums";
import { showReports } from "./utils/reports";

export const cfiNavigation = [
    {
        text: 'WORK',
        expanded: true,
        items: [
            {
                text: 'Action Required',
                icon: 'Inscyth-Action-Required',
                path: '/cfi/action-required',
                statID: 10000,
                expanded: false,
                items: [
                    {
                        text: 'Contact Customer',
                        path: '/cfi/action-required-orders/111',
                        statID: 111,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Enter Ready to Measure/Template Date',
                        path: '/cfi/action-required-orders/112',
                        statID: 112,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },

                    {
                        text: 'Enter Measure/Template Date',
                        path: '/cfi/action-required-orders/110',
                        statID: 110,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Upload Post Template Drawing',
                        path: '/cfi/action-required-orders/' + AR.CfiUploadPostTemplateDrawing,
                        statID: AR.CfiUploadPostTemplateDrawing,
                        visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'Enter Actual Measure Date',
                        path: '/cfi/action-required-orders/115',
                        statID: 115,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Template Checklist',
                        path: '/cfi/action-required-orders/117',
                        statID: 117,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) &&
                            !!company.assignedRetailers.find(x => x.companyCode === 'WREN')
                    },
                    {
                        text: 'Schedule Plumbing Disconnect',
                        path: '/cfi/action-required-orders/116',
                        statID: 116,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.PlumbingInstaller)
                    },
                    {
                        text: 'Schedule Plumbing Reconnect',
                        path: '/cfi/action-required-orders/119',
                        statID: 119,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.PlumbingInstaller)
                    },
                    {
                        text: 'Confirm/Change Order',
                        path: '/cfi/action-required-orders/120',
                        statID: 120
                    },
                    {
                        text: 'Validate Change Orders',
                        path: '/cfi/action-required-orders/' + AR.CfiValidateChangeOrder,
                        statID: AR.CfiValidateChangeOrder,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'Enter Scheduled Install/Delivery Date',
                        path: '/cfi/action-required-orders/143',
                        statID: 143,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Verify Cabinet Quality',
                        path: '/cfi/action-required-orders/138',
                        statID: 138,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Enter Actual Install/Delivery Date',
                        path: '/cfi/action-required-orders/145',
                        statID: 145,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'Enter Actual Install Start Date',
                        path: '/cfi/action-required-orders/155',
                        statID: 155,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Enter Lower Cabinets Plumb & Level Date',
                        path: '/cfi/action-required-orders/156',
                        statID: 156,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Enter Actual Install Completion Date',
                        path: '/cfi/action-required-orders/157',
                        statID: 157,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Installation Photos',
                        path: '/cfi/action-required-orders/147',
                        statID: 147,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) &&
                            !!company.assignedRetailers.find(x => x.companyCode === 'WREN')
                    },
                    {
                        text: 'Upload AOC/COC/POD',
                        path: '/cfi/action-required-orders/160',
                        statID: 160,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'Upload Work Verification Files',
                        path: '/cfi/action-required-orders/162',
                        statID: 162,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CCI) ||
                            company.installerTypes.includes(InstallerType.PlumbingInstaller)
                    },
                    {
                        text: 'Print Packing Slip',
                        path: '/cfi/action-required-orders/133',
                        statID: 133,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) &&
                            !!company.productLines.find(x => x.productLineID === ProductLine.LaminateDelivered ||
                                x.productLineID === ProductLine.SmallProjects)
                    },
                    {
                        text: 'MO - Invoice Due',
                        path: '/cfi/action-required-orders/225',
                        statID: 225,
                        visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'WO - Contact Customer',
                        path: '/cfi/action-required-orders/410',
                        statID: 410,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'WO - Schedule Appointment',
                        path: '/cfi/action-required-orders/420',
                        statID: 420,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'WO - Upload WOC',
                        path: '/cfi/action-required-orders/440',
                        statID: 440,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'WO - Enter Work Complete Date',
                        path: '/cfi/action-required-orders/430',
                        statID: 430,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Lead - Contact Customer',
                        path: '/cfi/action-required-orders/10',
                        statID: 10,
                        visible: (company: CompanyDetails) => company.SFI
                    },
                    {
                        text: 'Lead - Schedule Appointment',
                        path: '/cfi/action-required-orders/20',
                        statID: 20,
                        visible: (company: CompanyDetails) => company.SFI
                    },
                    {
                        text: 'Lead - Submit Estimate',
                        path: '/cfi/action-required-orders/30',
                        statID: 30,
                        visible: (company: CompanyDetails) => company.SFI
                    },
                    {
                        text: 'Lead - Pending Sale',
                        path: '/cfi/action-required-orders/40',
                        statID: 40,
                        visible: (company: CompanyDetails) => company.SFI
                    }
                ]
            },
            {
                text: 'Orders',
                icon: 'Inscyth-Orders',
                statID: 10010,
                expanded: false,
                visible: (company: CompanyDetails) =>
                    company.installerTypes.includes(InstallerType.CFI) ||
                    company.installerTypes.includes(InstallerType.CCI) ||
                    company.installerTypes.includes(InstallerType.PlumbingInstaller),
                items: [
                    {
                        text: 'Retail Orders',
                        path: '/cfi/orders/retail-orders',
                        statID: 10020,
                    },
                    {
                        text: 'Vanity Orders',
                        path: '/cfi/orders/vanity-orders',
                        statID: 10030,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) &&
                            !!company.productLines.find(x => x.productLineID === ProductLine.SmallProjects)
                    },
                    {
                        text: 'Material Orders',
                        path: '/cfi/orders/material-orders',
                        statID: 10040,
                        visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'Work Orders',
                        path: '/cfi/orders/work-orders',
                        statID: 10050,
                        visible: (company: CompanyDetails) =>
                            company.installerTypes.includes(InstallerType.CFI) ||
                            company.installerTypes.includes(InstallerType.CCI)
                    },
                    {
                        text: 'Back Orders',
                        path: '/cfi/orders/back-orders',
                        statID: 10060,
                        visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'Leads',
                        path: '/cfi/orders/leads',
                        statID: 10070,
                        visible: (company: CompanyDetails) => company.SFI
                    },
                    {
                        text: 'Estimates',
                        path: '/cfi/orders/estimates',
                        statID: 10080,
                        visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
                    },
                    {
                        text: 'Order Search',
                        path: '/cfi/orders/search',
                        visible: false
                    }
                ]
            },
            {
                text: 'Pending Change Orders',
                icon: 'Inscyth-Change-Orders',
                path: '/cfi/change-orders',
                statID: 10100,
                expanded: false,
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI),
                items: [
                    {
                        text: 'Pending Dealer',
                        path: '/cfi/change-orders/dealer',
                        statID: 10110
                    },
                    {
                        text: 'Pending Customer Payment',
                        path: '/cfi/change-orders/customer',
                        statID: 10120
                    },
                    {
                        text: 'Pending Sage',
                        path: '/cfi/change-orders/sage',
                        statID: 10130
                    },
                    {
                        text: 'Pending Corporate',
                        path: '/cfi/change-orders/corporate',
                        statID: 10140
                    }
                ]
            },
            {
                text: 'Back Ordered',
                path: '/cfi/back-ordered',
                icon: 'Inscyth-Back-Ordered',
                statID: 10200,
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
            },
            {
                text: 'Order Stock Material',
                path: '/cfi/material-order/new',
                icon: 'Inscyth-Order-Material',
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
            },
            {
                text: 'Easy Estimator',
                path: '/cfi/easy-estimator',
                icon: 'Inscyth-Easy-Estimator',
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
            },
            {
                text: 'Gimbil Mobile',
                path: '/cfi/gimbil',
                icon: 'Inscyth-Gimbil-Mobile-App',
                visible: (company: CompanyDetails) =>
                    company.installerTypes.includes(InstallerType.CFI) ||
                    company.installerTypes.includes(InstallerType.CCI)
            }
        ]
    },
    {
        text: 'MANAGEMENT',
        expanded: true,
        items: [
            {
                text: 'Metrics',
                path: '/cfi/metrics',
                icon: 'Inscyth-Metrics',
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)

            },
            {
                text: 'Reports',
                onClick: showReports,
                icon: 'Inscyth-Reports',
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)

            },
            {
                text: 'Announcement',
                path: '/announcement',
                icon: 'Inscyth-Announcement',
                statID: 10300
            },
            {
                text: 'Inactive Users',
                path: '/cfi/inactive-users',
                icon: 'Inscyth-Inactive-Users'
            }
        ]
    },
    {
        text: 'SUPPORTING ELEMENTS',
        expanded: true,
        items: [
            {
                text: 'Users',
                path: '/cfi/users',
                icon: 'Inscyth-Users'
            },
            {
                text: 'Material Cost',
                path: '/cfi/material-cost',
                icon: 'Inscyth-Material-Cost',
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)

            },
            {
                text: 'Payment Schedule',
                path: '/cfi/payment-schedule',
                icon: 'Inscyth-Payment-Schedule',
                visible: (company: CompanyDetails) =>
                    company.installerTypes.includes(InstallerType.CFI) ||
                    company.installerTypes.includes(InstallerType.CCI) ||
                    company.installerTypes.includes(InstallerType.PlumbingInstaller)
            },
            {
                text: 'Document Library',
                path: '/cfi/document-library',
                icon: 'Inscyth-Document-Library'
            },
            {
                text: 'Resource Guides',
                path: '/cfi/resource-guide',
                icon: 'Inscyth-Resource-Guide'
            },
            {
                text: 'Assigned Distributors',
                path: '/cfi/assigned-distributors',
                icon: 'Inscyth-Truck',
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
            },
            {
                text: 'Sage University',
                onClick: () => { window.open("https://sagesurfaces.app.workramp.com"); },
                icon: 'Inscyth-Graduation-Cap'
            },
            {
                text: 'Sage Solutions Institute',
                path: '/countertop-university',
                icon: 'Inscyth-Countertop-Academy',
                visible: (company: CompanyDetails) => company.installerTypes.includes(InstallerType.CFI)
            }
        ]
    },
    {
        text: 'SYSTEM CONFIGURATION',
        expanded: true,
        items: [
            {
                text: 'Integration',
                path: '/cfi/integration',
                icon: 'Inscyth-Integration'
            }
        ]
    },
    {
        text: 'CUSTOMER SERVICE',
        expanded: true,
        items: [
            {
                text: 'Help',
                path: '/cfi/help',
                icon: 'Inscyth-Help'
            }
        ]
    }
];


export const eeProNavigation = [
    {
        text: 'EE PRO',
        path: '/cfi/easy-estimator',
        icon: 'home',
        expanded: true,
        items: [
            {
                text: 'Portals',
                path: '/portals',
                icon: 'return'
            }
        ]
    }
];


export const dealerNavigation = [
    {
        text: 'WORK',
        expanded: true,
        items: [
            {
                text: 'Action Required',
                icon: 'Inscyth-Action-Required',
                path: '/dealer/action-required',
                statID: 10000,
                expanded: false,
                items: [
                    {
                        text: 'Submit Cabinet Design',
                        path: '/dealer/action-required-orders/134',
                        statID: 134,
                        visible: (company: CompanyDetails) =>
                            !!company.productLines.find(x => x.productLineID === ProductLine.Cabinets)
                    },
                    {
                        text: 'Confirm Change Order',
                        path: '/dealer/action-required-orders/122',
                        statID: 122
                    },
                    {
                        text: 'Upload Laminate Order Form',
                        path: '/dealer/action-required-orders/124',
                        statID: 124,
                        visible: (company: CompanyDetails) =>
                            !!company.productLines.find(x => x.productLineID === ProductLine.LaminateDelivered ||
                                x.productLineID === ProductLine.LaminateInstall)
                    },
                    {
                        text: 'Upload Vanity Order Form',
                        path: '/dealer/action-required-orders/123',
                        statID: 123,
                        visible: (company: CompanyDetails) =>
                            !!company.productLines.find(x => x.productLineID === ProductLine.SmallProjects)
                    },
                    {
                        text: 'Corporate to Accept Change Order',
                        path: '/dealer/action-required-orders/125',
                        statID: 125,
                        visible: (company: CompanyDetails) => (company.businessFlowID === BusinessFlow.CTG ||
                            company.businessFlowID === BusinessFlow.Online) && company.isParent
                    },
                    {
                        text: 'Enter Estimated Cabinet Delivery Date',
                        path: '/dealer/action-required-orders/135',
                        statID: 135,
                        visible: (company: CompanyDetails) =>
                            !!company.productLines.find(x => x.productLineID === ProductLine.Cabinets)
                    },
                    {
                        text: 'Enter Cabinet PO Received Date',
                        path: '/dealer/action-required-orders/137',
                        statID: 137,
                        visible: (company: CompanyDetails) =>
                            !!company.productLines.find(x => x.productLineID === ProductLine.Cabinets)
                    }
                ]
            },
            {
                text: 'Orders',
                icon: 'Inscyth-Orders',
                statID: 10010,
                expanded: false,
                items: [
                    {
                        text: 'Retail Orders',
                        path: '/dealer/orders/retail-orders',
                        statID: 10020
                    },
                    {
                        text: 'Vanity Orders',
                        path: '/dealer/orders/vanity-orders',
                        statID: 10030,
                        visible: (company: CompanyDetails) =>
                            !!company.productLines.find(x => x.productLineID === ProductLine.SmallProjects)
                    },
                    {
                        text: 'IME Orders',
                        path: '/dealer/orders/ime-orders',
                        statID: 10040,
                        visible: (company: CompanyDetails) => company.businessFlowID === BusinessFlow.Lowes
                    },
                    {
                        text: 'Work Orders',
                        path: '/dealer/orders/work-orders',
                        statID: 10050,
                    },
                    {
                        text: 'Order Search',
                        path: '/dealer/orders/search',
                        visible: false
                    }
                ]
            },
            {
                text: 'Easy Estimator',
                path: '/dealer/easy-estimator',
                icon: 'Inscyth-Easy-Estimator'
            },
            {
                text: 'Assigned Providers',
                path: '/dealer/assigned-cfis',
                icon: 'Inscyth-Assigned-CFIs'
            }
        ]
    },
    {
        text: 'MANAGEMENT',
        expanded: true,
        items: [
            {
                text: 'Announcement',
                path: '/announcement',
                icon: 'Inscyth-Announcement',
                statID: 10300
            },
            {
                text: 'Inactive Users',
                path: '/dealer/inactive-users',
                icon: 'Inscyth-Inactive-Users'
            }
        ]
    },
    {
        text: 'SUPPORTING ELEMENTS',
        expanded: true,
        items: [
            {
                text: 'Create User',
                path: '/dealer/create-user',
                icon: 'Inscyth-Users',
                visible: (company: CompanyDetails, user: MyAccountInformation) => user.isInternal
            },
            {
                text: 'Document Library',
                path: '/dealer/document-library',
                icon: 'Inscyth-Document-Library'
            },
            {
                text: 'Resource Guides',
                path: '/dealer/resource-guide',
                icon: 'Inscyth-Resource-Guide'
            },
            {
                text: 'Sage Solutions Institute',
                path: '/countertop-university',
                icon: 'Inscyth-Countertop-Academy',
            }
        ]
    },
    {
        text: 'CUSTOMER SERVICE',
        expanded: true,
        items: [
            {
                text: 'Help',
                path: '/dealer/help',
                icon: 'Inscyth-Help'
            }
        ]
    }
];


export const distributorNavigation = [
    {
        text: 'WORK',
        expanded: true,
        items: [
            {
                text: 'Action Required',
                icon: 'Inscyth-Action-Required',
                path: '/distributor/action-required',
                statID: 10000,
                expanded: false,
                items: [
                    {
                        text: 'Distributor to Validate Ship Date',
                        path: '/distributor/action-required-orders/340',
                        statID: 340,
                        visible: (company: CompanyDetails) => !!company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')
                    },
                    {
                        text: 'Distributor to Enter Ship Date',
                        path: '/distributor/action-required-orders/350',
                        statID: 350,
                        visible: (company: CompanyDetails) => !!company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')
                    },
                    {
                        text: 'Distributor to Validate Delivery Date',
                        path: '/distributor/action-required-orders/341',
                        statID: 341,
                        visible: (company: CompanyDetails) => !company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')

                    },
                    {
                        text: 'Distributor to Enter Delivery Date',
                        path: '/distributor/action-required-orders/351',
                        statID: 351,
                        visible: (company: CompanyDetails) => !company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')
                    },
                    {
                        text: 'Distributor to Invoice',
                        path: '/distributor/action-required-orders/360',
                        statID: 360
                    },
                    {
                        text: 'Distributor to Approve Cancellation',
                        path: '/distributor/action-required-orders/344',
                        statID: 344
                    }
                ]
            },
            {
                text: 'Purchase Orders',
                icon: 'Inscyth-Orders',
                statID: 10010,
                path: '/distributor/orders'
            },
            {
                text: 'Order Search',
                path: '/distributor/orders/search',
                visible: false
            },
            {
                text: 'Credit Memos List',
                path: '/distributor/credit-memos',
                icon: 'Inscyth-Payment-Schedule'
            }
        ]
    },
    {
        text: 'MANAGEMENT',
        expanded: true,
        items: [
            {
                text: 'Reports',
                path: '/distributor/reports',
                icon: 'Inscyth-Reports'
            },
            {
                text: 'Announcement',
                path: '/announcement',
                icon: 'Inscyth-Announcement',
                statID: 10300
            },
            {
                text: 'Out of Stock',
                path: '/distributor/out-of-stock',
                icon: 'Inscyth-Out-of-Stock',
                statID: 10310
            },
            {
                text: 'Late Deliveries',
                path: '/distributor/late-deliveries',
                icon: 'Inscyth-Late-Shipments',
                statID: 10320
            },
            {
                text: 'Days to Delivery',
                path: '/distributor/days-to-delivery',
                icon: 'Inscyth-Average-Days-to-Ship'
            },
            {
                text: 'CFI Routing',
                path: '/distributor/cfi-routing',
                icon: 'Inscyth-Truck'
            },
            {
                text: 'Inactive Users',
                path: '/distributor/inactive-users',
                icon: 'Inscyth-Inactive-Users'
            }
        ]
    },
    {
        text: 'SUPPORTING ELEMENTS',
        expanded: true,
        items: [
            {
                text: 'Document Library',
                path: '/distributor/document-library',
                icon: 'Inscyth-Document-Library'
            }
        ]
    },
];

export const manufacturerNavigation = [
    {
        text: 'WORK',
        expanded: true,
        items: [
            {
                text: 'Action Required',
                icon: 'Inscyth-Action-Required',
                path: '/manufacturer/action-required',
                statID: 10000,
                expanded: false,
                items: [
                    {
                        text: 'Distributor to Validate Ship Date',
                        path: '/distributor/action-required-orders/340',
                        statID: 340,
                        visible: (company: CompanyDetails) => !!company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')

                    },
                    {
                        text: 'Distributor to Enter Ship Date',
                        path: '/distributor/action-required-orders/350',
                        statID: 350,
                        visible: (company: CompanyDetails) => !!company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')

                    },
                    {
                        text: 'Distributor to Validate Delivery Date',
                        path: '/manufacturer/action-required-orders/341',
                        statID: 341,
                        visible: (company: CompanyDetails) => !company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')

                    },
                    {
                        text: 'Distributor to Enter Delivery Date',
                        path: '/manufacturer/action-required-orders/351',
                        statID: 351,
                        visible: (company: CompanyDetails) => !company.productLines?.find(x => x.productLineCode === 'SamplesLiterature')
                    },
                    {
                        text: 'Distributor to Invoice',
                        path: '/manufacturer/action-required-orders/360',
                        statID: 360
                    },
                    {
                        text: 'Distributor to Approve Cancellation',
                        path: '/manufacturer/action-required-orders/344',
                        statID: 344
                    }
                ]
            },
            {
                text: 'Purchase Orders',
                icon: 'Inscyth-Orders',
                statID: 10010,
                path: '/manufacturer/orders'
            },
            {
                text: 'Order Search',
                path: '/manufacturer/orders/search',
                visible: false
            },
            {
                text: 'Credit Memos List',
                path: '/manufacturer/credit-memos',
                icon: 'Inscyth-Payment-Schedule'
            }
        ]
    },
    {
        text: 'MANAGEMENT',
        expanded: true,
        items: [
            {
                text: 'Reports',
                path: '/manufacturer/reports',
                icon: 'Inscyth-Reports'
            },
            {
                text: 'Announcement',
                path: '/announcement',
                icon: 'Inscyth-Announcement',
                statID: 10300
            },
            {
                text: 'Out of Stock',
                path: '/manufacturer/out-of-stock',
                icon: 'Inscyth-Out-of-Stock',
                statID: 10310
            },
            {
                text: 'Late Deliveries',
                path: '/manufacturer/late-deliveries',
                icon: 'Inscyth-Late-Shipments',
                statID: 10320
            },
            {
                text: 'Days to Delivery',
                path: '/manufacturer/days-to-delivery',
                icon: 'Inscyth-Average-Days-to-Ship'
            },
            {
                text: 'Inactive Users',
                path: '/manufacturer/inactive-users',
                icon: 'Inscyth-Inactive-Users'
            }
        ]
    },
    {
        text: 'SUPPORTING ELEMENTS',
        expanded: true,
        items: [
            {
                text: 'Document Library',
                path: '/manufacturer/document-library',
                icon: 'Inscyth-Document-Library'
            }
        ]
    }
];

export const serviceProviderNavigation = [
    {
        text: 'WORK',
        expanded: true,
        items: [
            {
                text: 'Action Required',
                icon: 'Inscyth-Action-Required',
                path: '/service-provider/action-required',
                statID: 10000,
                expanded: false,
                items: [
                    {
                        text: 'Enter Service Initiated Date',
                        path: '/service-provider/action-required-orders/370',
                        statID: 370
                    },
                    {
                        text: 'Invoice',
                        path: '/service-provider/action-required-orders/380',
                        statID: 380
                    }
                ]
            },
            {
                text: 'Purchase Orders',
                icon: 'Inscyth-Orders',
                statID: 10010,
                path: '/service-provider/orders'
            },
            {
                text: 'Order Search',
                path: '/service-provider/orders/search',
                visible: false
            },
            {
                text: 'Credit Memos List',
                path: '/service-provider/credit-memos',
                icon: 'Inscyth-Payment-Schedule'
            }
        ]
    },
    {
        text: 'MANAGEMENT',
        expanded: true,
        items: [
            {
                text: 'Announcement',
                path: '/announcement',
                icon: 'Inscyth-Announcement',
                statID: 10300
            },
            {
                text: 'Inactive Users',
                path: '/service-provider/inactive-users',
                icon: 'Inscyth-Inactive-Users'
            }
        ]
    },
    {
        text: 'SUPPORTING ELEMENTS',
        expanded: true,
        items: [
            {
                text: 'Document Library',
                path: '/service-provider/document-library',
                icon: 'Inscyth-Document-Library'
            }
        ]
    }
];
